import { render, staticRenderFns } from "./assembleOrdersInfo.vue?vue&type=template&id=d1b153ac&scoped=true"
import script from "./assembleOrdersInfo.vue?vue&type=script&lang=js"
export * from "./assembleOrdersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1b153ac",
  null
  
)

export default component.exports